import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import * as tConst from "../../../common/Constants";
import ChildrenMenuToolbar from "./ChildrenMenuToolbar"
import ChartMenuToolbar from "./ChartMenuToolbar"
import ChartMenuForm from "./ChartMenuForm";
import * as AzureService from "../../../api/ticketsApiAzure";
import prepareTicket from "../data/prepareTicket";



const ChartMenuAdo = ({ ...props }) => {
  const [childrenIds, setChildrenIds] = useState([]);
  const [children, setChildren] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [refreshChildren, setRefreshChildren] = useState();
  const [refreshOnClose, setRefreshOnClose] = useState(false);


  useEffect(() => {
    if (props.auth && props.auth.un !== "" && props.auth.pw !== "" && props.selectedTicket) {
      setIsLoaded(false);

      AzureService.getChildrenList(props.auth, props.selectedTicket?.id).then(async (response) => {
        setChildrenIds(response);
      });
    }
  }, [props.auth, props.selectedTicket, refreshChildren]);

  useEffect(() => {
    if (childrenIds?.length > 0) {

      if (props.auth && props.auth.un !== "" && props.auth.pw !== "") {

        AzureService.getItems(props.auth, childrenIds).then(async (response) => {
          const _item = response.value.map((item) => {
            console.log("2025-01-03 - prepareTicket**", item.fields[tConst.AF_PLANNING_PRIORITY], item.fields[tConst.AF_PLANNING_PRIORITY], item.fields[tConst.AF_PLANNING_PRIORITY], 1000000)
            return prepareTicket(item);
          })
          setChildren(_item);
          setIsLoaded(true);
        });
      }
    }
    else {
      setChildren([])
      setIsLoaded(true);
    }
  }, [props.auth, childrenIds]);

  const close = (refresh = false) => {
    if (refresh || refreshOnClose) {
      props.onSetRefresh();
    }
    props.handleClose();
    console.log("Close");
  }


  if (props.showChartMenu && props.selectedTicket) {
    const _fromDate = new Date(props.selectedTicket.fields[tConst.AF_START_ITERATION]);
    const _toDate = new Date(props.selectedTicket.fields[tConst.AF_END_ITERATION]);
    const _assignedTo = props.selectedTicket.fields[tConst.AF_ASSIGNED_TO];
    const _initiaitve = props.selectedTicket.fields[tConst.AF_INITIATIV];
    const _jiraLink = props.selectedTicket ? "https://jira.sensio.no/browse/" + props.selectedTicket.fields[tConst.AF_JIRA_LINK] : "";
    return (
      <>
        <Modal show={props.showChartMenu} dialogClassName="modal-lg">
          <Modal.Header>
            <Modal.Title>
              <a href={tConst.AZURE_DEVOPS_BASE_TICKET_URI + props.menuTicketID} target="_blank" rel="noopener noreferrer">
                [{props.menuTicketID}]
              </a>
              &nbsp;
              {props.selectedTicket?.fields[tConst.AF_TITLE]}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ChartMenuToolbar
              auth={props.auth}
              selectedTicket={props.selectedTicket}
              onMoveAndExtendIteration={props.onMoveAndExtendIteration}
              children={children}
              isLoaded={isLoaded}
              setRefreshOnClose={() => setRefreshOnClose(true)}
              onRefreshChildren={() => {
                setRefreshChildren(Date.now());
              }}
              onClose={() => {
                close(true);
              }}
            />
            <div>
              <ChartMenuForm
                selectedTicket={props.selectedTicket}
                fromDate={_fromDate}
                toDate={_toDate}
                assignedTo={_assignedTo}
                initiaitve={_initiaitve}
                jiraLink={_jiraLink}
                onUpdateTicket={props.onUpdateTicket}
                onSetRefresh={props.onSetRefresh}
              />
            </div>


            {/* <hr/>
              <ChartMenuMoveExtendButtons 
                selectedTicket={selectedTicket} 
                onMoveAndExtendIteration = {props.onMoveAndExtendIteration}
                enableHalfIterations = {props.enableHalfIterations}
              /> */}
            <hr />
            <ChildrenMenuToolbar
              children={children}
              isLoaded={isLoaded}
              auth={props.auth}
              selectedTicket={props.selectedTicket}
              onPlanningToChildren={() => { props.onPlanningToChildren(props.selectedTicket) }}
              setRefreshOnClose={() => setRefreshOnClose(true)}
              onSetRefresh={() => {
                setRefreshChildren(Date.now());
              }}

              onClose={() => {
                close(true);
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => {
              close();
            }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  else {
    return <></>
  }

}

export default ChartMenuAdo;
